import cn from 'classnames';

import React from 'react';
import styles from './styles.module.scss';

const SelectLine = ({
  item,
  disabled = false,
  index,
  onSelect,
  onMouseOver = () => {},
  focus = false,
  small = false,
  big = false,
  style,
  ...props
}) => (
  <div
    className={cn(
      styles.select_line,
      disabled && styles.disabled_line,
      small && styles.select_line_small,
      big && styles.select_line_big,
      focus && !disabled && styles.focus,
    )}
    onMouseOver={onMouseOver}
    onClick={() => (disabled ? {} : onSelect())}
    {...props}
  >
    {item}
  </div>
);

export default SelectLine;
